// src/components/messenger/ChatMessage.tsx
import React from 'react';
import { ErrorMessage, MessageBubble, MessageText, MessageWrapper, RetryButton } from '../../styles/messenger/messenger.style';
import { Message } from '../../hooks/useMessages'; // Import the full Message type
import {
  MessageRow,
  // MessageBubble,
  MessageActions,
  ActionIconButton,
  RepliedMessageBlock,
  RepliedSenderName,
  MessageGroup,
  InlineTimestamp,
  MessageContent,
} from '../../styles/messenger/messenger.style';
import { MessageStatus } from './MessageStatus'; // 👈 1. Import the new component
import { ArrowReturnLeft } from 'react-bootstrap-icons';
import { RefreshCcw } from 'lucide-react';


interface ChatMessageProps {
  message: Message;
  currentUserId: string;
  repliedToSenderName: string | null;
  onRetry: (message: Message) => void;
  onStartReply: (message: Message) => void;
  isNewGroup: boolean;

}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message, currentUserId, onRetry, onStartReply, isNewGroup, repliedToSenderName}) => {
  const sentByMe = message.senderId === currentUserId;
  console.log(`Message status:  ${message.status}`)
  return (
    // 2. Use MessageRow as the main container for alignment and hover effects
    <MessageRow isNewGroup={isNewGroup}>
      {/* 👇 Wrap the bubble and actions in our new MessageGroup component */}
      <MessageGroup sentByMe={sentByMe}>
        <MessageBubble sentByMe={sentByMe} status={message.status}>
          {message.replyTo && repliedToSenderName && (
            <RepliedMessageBlock sentByMe={sentByMe}>
              <RepliedSenderName sentByMe={sentByMe}>
                {sentByMe ? 'You' : repliedToSenderName.split(' ')[0]} replied to{' '}
                {sentByMe ? repliedToSenderName.split(' ')[0] : 'you'}
              </RepliedSenderName>
              <p>{message.replyTo.content}</p>
            </RepliedMessageBlock>
          )}
          <MessageText>{message.content}</MessageText>
          {/* <MessageContent>
            <MessageText>{message.content}</MessageText>
            <MessageStatus message={message} sentByMe={sentByMe} />
          </MessageContent> */}
          {/* <span>{message.content}</span> */}
        </MessageBubble>

        <MessageActions className="message-actions">
          {sentByMe && message.status === 'failed' && (
            <ActionIconButton onClick={() => onRetry(message)}>
              <RefreshCcw size={16}  />
            </ActionIconButton>
          )}
          {message.status !== 'failed' && (
          <ActionIconButton onClick={() => onStartReply(message)}>
            <ArrowReturnLeft size={16} />
          </ActionIconButton>
          )}
        </MessageActions>
      </MessageGroup>
    </MessageRow>

  );
};